import { Injectable, signal } from '@angular/core';
import { AppSettings } from '../app.settings';
import { StorageService } from './storage.service';

export interface TenantCode {
  tenantCode: string;
}


@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private loggedInTenantCode = signal<string>('');

  constructor(private storageService: StorageService,
  ) { }

  setLoggedInTenantCode(tenantCode: string): void {
    this.loggedInTenantCode.set(tenantCode);
  }

  getLoggedInTenantCodeFromSession(): string {
    return this.loggedInTenantCode();
  }

  getStaticTenantCode() {
    return AppSettings.TENANT_CODE;
  }

  isSponsorUser(): boolean {
    const profileData = JSON.parse(localStorage.getItem(AppSettings.PROFILE_DATA));
    if (!profileData || !Array.isArray(profileData.roleListDto)) {
      return false;
    }

    return profileData.roleListDto.some(role => role.roleCode === "SPONSOR");
  }


  isSiteUser(): boolean {
    const profileData = JSON.parse(localStorage.getItem(AppSettings.PROFILE_DATA));
    if (!profileData || !Array.isArray(profileData.roleListDto)) {
      return false;
    }

    return profileData.roleListDto.some(role => role.roleCode === "SITE_USER");
  }

  getHomeRoute(): string {
    return this.isSiteUser() ? '/app/orders' : '/app/dashboard';
  }

  isAdmin(): boolean {
    return this.isTenantAdmin() || this.isReviewer();
  }

  isTenantAdmin(): boolean {
    const profileData = JSON.parse(localStorage.getItem(AppSettings.PROFILE_DATA));
    if (!profileData || !Array.isArray(profileData.roleListDto)) {
      return false;
    }

    return profileData.roleListDto.some(role => role.roleCode === AppSettings.USER_TYPES.TENANT_ADMIN);
  }

  isReviewer(): boolean {
    const profileData = JSON.parse(localStorage.getItem(AppSettings.PROFILE_DATA));
    if (!profileData || !Array.isArray(profileData.roleListDto)) {
      return false;
    }

    return profileData.roleListDto.some(role => role.roleCode === AppSettings.USER_TYPES.REVIEWER);
  }

  isSponsor(): boolean {
    const profileData = JSON.parse(localStorage.getItem(AppSettings.PROFILE_DATA));
    if (!profileData || !Array.isArray(profileData.roleListDto)) {
      return false;
    }

    return profileData.roleListDto.some(role => role.roleCode === AppSettings.USER_TYPES.SPONSOR);
  }


  getLoggedInTenantCode() {
    const tenant = AppSettings.TENANT_CODE.toUpperCase();
    const profileData = JSON.parse(localStorage.getItem(AppSettings.PROFILE_DATA));
    return profileData?.tenantCode || tenant;
  }

  getForTenant() {
    const forTenantDetails = JSON.parse(localStorage.getItem(AppSettings.FOR_TENANT_AND_COUNTRY_DETAILS));
    return forTenantDetails.tenant || {};
  }

  getForTenantId() {
    const forTenantDetails = JSON.parse(localStorage.getItem(AppSettings.FOR_TENANT_AND_COUNTRY_DETAILS));
    return forTenantDetails?.tenant?.tenantId || this.getLoggedInTenantCode();
  }

  getForTenantCode() {
    const forTenantDetails = JSON.parse(localStorage.getItem(AppSettings.FOR_TENANT_AND_COUNTRY_DETAILS));
    return forTenantDetails?.tenant?.tenantCode || this.getLoggedInTenantCode();
  }


  getSelectedCountry() {
    const countryDetails = JSON.parse(localStorage.getItem(AppSettings.FOR_TENANT_AND_COUNTRY_DETAILS));
    return countryDetails.country || {};
  }

  getSelectedCountryId() {
    const countryDetails = JSON.parse(localStorage.getItem(AppSettings.FOR_TENANT_AND_COUNTRY_DETAILS));
    return countryDetails.country.countryId || "2";
  }


}
